import Vue from "vue";
import VueRouter from "vue-router";
import CardsView from "@/views/cards.vue";
import CardView from "@/views/card-big.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "*",
    redirect: "/cards/one-to-thirteen"
  },
  {
    path: "/cards/:cardSetName",
    name: "cards",
    component: CardsView,
    props: true
  },
  {
    path: "/card/:cardValue",
    name: "card",
    component: CardView,
    props: true
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
